// extracted by mini-css-extract-plugin
export default {"imagesWrapper":"WF-z"};